<nav
    aria-label="breadcrumb"
    *ngIf="(breadcrumbService.breadcrumbs || []).length > 0 && isUserLoggedIn()"
    class="my-2"
>
    <ol class="breadcrumb">
        <li
            *ngFor="let breadcrumb of breadcrumbService.breadcrumbs"
            [ngClass]="{'active': breadcrumb.active}"
            class="breadcrumb-item"
        >
            <a
                *ngIf="!breadcrumb.active"
                [routerLink]="[breadcrumb.path]"
               
                >{{breadcrumb.name}}
            </a>
            <ng-container
                *ngIf="breadcrumb.active"
            >{{breadcrumb.name}}</ng-container
            >
        </li>
    </ol>
</nav>
